module.exports = __webpack_public_path__ + "img/galeria-florestal-2.49bf3561.jpg";